import React, { useEffect, useRef, useState } from "react";
import { useField } from "formik";
import calendar from "../../images/icons/calendar.png";
import "./DateRangePicker.css";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format, addDays } from "date-fns";

const DateRangePicker = (props) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error;
  const { value } = meta;

  const [showCalendar, setShowCalendar] = useState(false);
  const inputDateRangeRef = useRef(null);
  const refDatePickerCalender = useRef(null);

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 8),
      key: "selection",
    },
  ]);

  const clickShowCalender = (e) => {
    if (!props.disabled) {
      inputDateRangeRef.current.focus();
      setShowCalendar((open) => !open);
    }
  };

  const hideOnOutside = (e) => {
    if (
      refDatePickerCalender.current &&
      !refDatePickerCalender.current.contains(e.target)
    ) {
      setShowCalendar(false);
    }
  };

  const handleDateRangeChange = (e) => {
    if (props.onChange) props.onChange(value);
    if (props.format) {
      value = props.format(value) || "";
    }
    if (!!props.counter && props.counter < value.length) {
      return;
    }
  };

  useEffect(() => {
    if (value == null || value == "") {
      helpers.setValue(dateRange);
    }

    document.addEventListener("click", hideOnOutside, true);

    document.addEventListener("change", handleDateRangeChange, true);
    return () => {
      document.removeEventListener("change", handleDateRangeChange, true);
    };
  }, [value]);

  return (
    <div className="date-picker">
      <div
        className={`input_wrapper ${hasError ? "input_wrapper has_error" : ""} ${
          props.customclass
        } ${props.disabled ? "input_wrapper_disabled" : ""}`}
      >
        {props.label && (
          <label
            style={{ color: props.labelColor }}
            className="label"
            htmlFor={props.name}
          >
            {props.label}
          </label>
        )}

        <div className="input overflowHidden" onClick={clickShowCalender}>
          <input
            ref={inputDateRangeRef}
            name={props.name}
            {...field}
            className="inputBox input-right-side_text"
            onChange={(e) => {
              handleDateRangeChange(e);
            }}
            value={
              value
                ? `${format(value[0].startDate, "dd MMM yyyy")} - ${format(
                    value[0].endDate,
                    "dd MMM yyyy"
                  )}`
                : `${format(dateRange[0].startDate, "dd MMM yyyy")} - ${format(
                  dateRange[0].endDate,
                    "dd MMM yyyy"
                  )}`
            }
            readOnly
            style={{
              paddingRight: props.counter && "70px",
            }}
            autoComplete="off"
            disabled={props.disabled}
          />
          <div
            className="right-side_icon"
            style={{ borderLeft: "1px solid #ebebeb" }}
          >
            <img src={calendar} alt="" className="calendar-icon" />
          </div>

          {props.counter && (
            <span
              className={`${
                field.value.length === props.counter && "counter_error"
              } counter`}
            >
              {field.value.length} / {props.counter}
            </span>
          )}
        </div>
        {hasError ? (
          <div className="error__text">{props.customError || meta.error}</div>
        ) : null}
      </div>
      <div ref={refDatePickerCalender}>
        {showCalendar && (
          <DateRange
            onChange={(item) => {
              setDateRange([item.selection]);
              const inputEl = inputDateRangeRef.current;
              if (inputEl) {
                inputEl.dispatchEvent(new Event("change", { bubbles: true }));
                helpers.setValue([item.selection]);
              }
            }}
            className={`calendarElement ${hasError && "mt_-14"}`}
            ranges={value || dateRange}
            editableDateInputs={true}
          />
        )}
      </div>
    </div>
  );
};

export default DateRangePicker;
